/**
 * Clicks on a dashboard date-range calendar: the first click while the picker is open
 * is that day alone, the second spans the two clicked days.
 *
 * react-day-picker's own range logic grows the range already picked: with Sep 30
 * picked, a click on Sep 29 gave Sep 29 → Sep 30, and a click on the picked day
 * cleared it — so after the first pick the dashboard never showed the day clicked
 * (reported 2026-09-30). Reset the anchor whenever the picker opens.
 */
export interface DayRangeClick {
  range: { from: Date; to: Date };
  /** First click waiting for an optional second one; null once the range is done. */
  anchor: Date | null;
  done: boolean;
}

export function nextDayRange(anchor: Date | null, clicked: Date): DayRangeClick {
  if (!anchor) return { range: { from: clicked, to: clicked }, anchor: clicked, done: false };
  const [from, to] = clicked < anchor ? [clicked, anchor] : [anchor, clicked];
  return { range: { from, to }, anchor: null, done: true };
}
